
import { Button, Card, DatePicker, Form, Input, notification, Select } from "antd";
import dayjs from "dayjs";
import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { API } from "../../../config/api";
import { GET, PUT } from "../../../utils/apicalls";
function UpdateInternship() {
  const [form] = Form.useForm();
  const [data, setData] = useState<any>([]);
  const [isLoading, setIsLoading] = useState(false);
  const [mode, setMode] = useState(null);

  const timeSlots = ["online-10:00 AM - 12:00 PM", "online-2:00 PM - 4:00 PM", "online-8:00 PM - 10:00 PM"];

  const navigate = useNavigate();
  const { id } = useParams();
  const UpdateHandler = async (values: any) => {
    try {
      let obj = {
        internName: values.internName,
        internAddress: values.internAddress,
        internEmail: values.internEmail,
        phone: values.phone,
        joinDate: values.joinDate ? values.joinDate.format("YYYY-MM-DD") : null, // Convert to correct format
        PayementAmount: Number(values.PayementAmount),
        internpayment: values.internpayment,
        PayementType: values.PayementType,
        mode: values.mode,

      };

      setIsLoading(true);
      let api = API.EDIT_INTERN_DETAILS + id;
      const postRequest: any = await PUT(api, obj);
      if (postRequest.status) {
        notification.success({
          message: " updated successfully!",
        });
        form.resetFields();
        fetchone();
        navigate(-1);
      } else {
        notification.error({ message: "Something went wrong" });
      }
    } catch (error) {
      console.error(error);
      notification.error({
        message: "Something went wrong! Please try again later",
      });
    } finally {
      setIsLoading(false);
    }
  };

  const fetchone = async () => {
    try {
      setIsLoading(true);
      let api = API.FIND_ONE_INTERN + id;
      const response: any = await GET(api, {});

      // Ensure date fields are converted properly
      const formattedData = {
        ...response?.data,
        joinDate: response?.data?.joinDate ? dayjs(response.data.joinDate) : null, // Convert date to a valid format
        internpayment: response?.data?.internpayment ? dayjs(response.data.joinDate) : null, // Convert date to a valid format
      };

      setData(formattedData);
      form.setFieldsValue(formattedData);
    } catch (error) {
      console.error(error);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    fetchone();
  }, []);

  return (
    <div>
      <h1>Update Intern Details page</h1>
      <Card>
        <Form form={form} onFinish={UpdateHandler} layout="vertical">
          <Form.Item
            name="internName"
            label="internName"
            rules={[{ required: true }]}
          >
            <Input />
          </Form.Item>
          <Form.Item
            name="internAddress"
            label="internAddress"
            rules={[{ required: true }]}
          >
            <Input />
          </Form.Item>
          <Form.Item
            name="internEmail"
            label="internEmail"
            rules={[{ required: true }]}
          >
            <Input />
          </Form.Item>
          <Form.Item
            name="phone"
            label="phone"
            rules={[{ required: true }]}
          >
            <Input />
          </Form.Item>
          <Form.Item
            name="joinDate"
            label="joinDate"
            rules={[{ required: true }]}
          >
            <DatePicker />
          </Form.Item>
          <Form.Item name="mode" label="Mode" rules={[{ required: true, message: "Please select a mode" }]}>
            <Select placeholder="Select mode" onChange={(value) => setMode(value)}>
              <Select.Option value="online">Online</Select.Option>
              <Select.Option value="offline">Offline</Select.Option>
            </Select>
          </Form.Item>

          {mode === "online" && (
            <Form.Item name="mode" label="Time Slot" rules={[{ required: true, message: "Please select a time slot" }]}>
              <Select placeholder="Select a time slot">
                {timeSlots.map((slot) => (
                  <Select.Option key={slot} value={slot}>{slot}</Select.Option>
                ))}
              </Select>
            </Form.Item>
          )}

          <Form.Item name="internpayment" label="internpayment" rules={[{ required: true }]}>
            <DatePicker />
          </Form.Item>
          <Form.Item name="PayementAmount" label="PayementAmount" rules={[{ required: true }]}>
            <Input />
          </Form.Item>
          <Form.Item name="PayementType" label="Payement type" rules={[{ required: true }]}>
            <Select placeholder="Select a Payement type" allowClear>
              <Select.Option value="advance">Advance</Select.Option>
              <Select.Option value="Balance_payement">Balance payement</Select.Option>

            </Select>
          </Form.Item>


          <Button type="primary" htmlType="submit" block>
            Submit
          </Button>
        </Form>
      </Card>
    </div>
  )
}

export default UpdateInternship
